import { api } from './api';
import { MomentumData } from '../types/momentum.types';

export const momentumService = {
  /**
   * Get momentum data for a specific page
   */
  async getMomentum(
    pageId: number,
    engine: 'google' | 'bing' = 'google',
    window: 28 | 90 = 28
  ): Promise<MomentumData> {
    const response = await api.get<MomentumData>(
      `/coreapi/pages/${pageId}/momentum`,
      { params: { engine: engine.toUpperCase(), window } }
    );
    return response.data;
  },

  /**
   * Get momentum for multiple pages
   */
  async getBatchMomentum(
    pageIds: number[],
    engine: 'google' | 'bing' = 'google',
    window: 28 | 90 = 28
  ): Promise<Record<number, MomentumData>> {
    const response = await api.post<Record<number, MomentumData>>(
      `/coreapi/momentum/batch`,
      { pageIds, engine: engine.toUpperCase(), window }
    );
    return response.data;
  },

  /**
   * Recompute momentum for a page
   */
  async recomputeMomentum(
    pageId: number,
    engine: 'google' | 'bing' = 'google',
    window: 28 | 90 = 28
  ): Promise<MomentumData> {
    const response = await api.post<MomentumData>(
      `/coreapi/pages/${pageId}/momentum/recompute`,
      { engine: engine.toUpperCase(), window }
    );
    return response.data;
  },

  /**
   * Get momentum history for a page
   */
  async getMomentumHistory(
    pageId: number,
    engine: 'google' | 'bing' = 'google',
    limit: number = 30
  ): Promise<MomentumData[]> {
    const response = await api.get<{ content: MomentumData[] }>(
      `/coreapi/pages/${pageId}/momentum/history`,
      { params: { engine: engine.toUpperCase(), limit } }
    );
    return response.data.content || [];
  },
};
